import { blockUI } from 'angular';

import { IntegrationQuotePricesModel }           from '../../app-lite/integrations/typings/integration.quote-prices';
import { VehicleRegistrationRequestQuoteModel }  from './models/vehicle-registration.request-quote';
import { VehicleRegistrationServiceAjs }         from './vehicle-registration.service.ajs';

interface PurchaseVehicleRegistrationRequestsScope extends ng.IScope {
  block          : blockUI.BlockUIService;
  getCurrentPrice: () => string;
  prices         : IntegrationQuotePricesModel;
  purchase       : () => void;
  quote          : VehicleRegistrationRequestQuoteModel;
  updateTotal    : () => void;
}

export function PurchaseVehicleRegistrationRequestsCtrl (
  $uibModalInstance     : ng.ui.bootstrap.IModalInstanceService,
  $scope                : PurchaseVehicleRegistrationRequestsScope,
  $translate            : ng.translate.ITranslateService,
  blockUI               : blockUI.BlockUIService,
  confirm               : any,
  messages              : any,
  prices                : IntegrationQuotePricesModel,
  vehicleRegistrationApi: VehicleRegistrationServiceAjs
) {
  $scope.block  = blockUI.instances.get('purchaseRequestBlock');
  $scope.prices = prices;
  $scope.quote  = {
    price   : $scope.prices.low_price,
    quantity: 0,
    total   : '0.00'
  };

  $scope.getCurrentPrice = function () {
    return vehicleRegistrationApi.getCurrentPrice($scope.quote.quantity, $scope.prices);
  };

  $scope.purchase = function () {
    $scope.block.start();

    vehicleRegistrationApi.confirmPurchase($scope.quote)
    .then(() => {
      $uibModalInstance.close();

      messages.show($translate.instant('JS_SPACE.MESSAGES.PURCHASE_SUCCESSFUL'), 'success');
    })
    .then(() => confirm.notify({
      message: $translate.instant('JS_SPACE.MESSAGES.THANK_YOU_PURCHASE_MESSAGE')
    }))
    .catch(err => {
      messages.error(err);
    })
    .finally( () => {
      $scope.block.stop();
    });
  };

  $scope.updateTotal = function () {
    vehicleRegistrationApi.getQuote($scope.quote)
    .then(( quote : VehicleRegistrationRequestQuoteModel ) => {
      $scope.quote = quote;
    })
    .catch(err => {
      messages.error(err);
    });
  };
}